import { c as _c } from "react/compiler-runtime";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import Image from "next/image";
export default function WaveMentionsTypeaheadMenuItem(t0) {
  const $ = _c(22);
  const {
    index,
    isSelected,
    onClick,
    onMouseEnter,
    name,
    picture,
    setRefElement
  } = t0;
  const t1 = "typeahead-item-" + index;
  const t2 = `${isSelected ? "tw-bg-iron-700" : "tw-bg-transparent"} tw-relative tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-justify-between tw-rounded-lg tw-border-none tw-px-2 tw-py-2 tw-text-left tw-text-white tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400`;
  let t3;
  if ($[0] !== name || $[1] !== picture) {
    t3 = picture && <div className="tw-h-6 tw-w-6 tw-overflow-hidden tw-rounded-md tw-bg-iron-900 tw-ring-1 tw-ring-white/10"><div className="tw-h-full tw-w-full tw-max-w-full"><div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-text-center"><Image src={getScaledImageUri(picture, ImageScale.W_AUTO_H_50)} alt={`Wave ${name}`} width={24} height={24} className="tw-mx-auto tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-bg-transparent tw-object-contain" /></div></div></div>;
    $[0] = name;
    $[1] = picture;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== name) {
    t4 = <div><div className="tw-w-[14rem] tw-truncate tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-white">{name}</div></div>;
    $[3] = name;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className="tw-inline-flex tw-items-center tw-space-x-2">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isSelected) {
    t6 = isSelected && <svg className="tw-ml-2 tw-h-5 tw-w-5 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[8] = isSelected;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="tw-inline-flex tw-w-full tw-items-center tw-justify-between">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onClick || $[14] !== onMouseEnter || $[15] !== t2 || $[16] !== t7) {
    t8 = <button onMouseEnter={onMouseEnter} onClick={onClick} type="button" className={t2}>{t7}</button>;
    $[13] = onClick;
    $[14] = onMouseEnter;
    $[15] = t2;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== setRefElement || $[19] !== t1 || $[20] !== t8) {
    t9 = <li className="tw-h-full" ref={setRefElement} id={t1}>{t8}</li>;
    $[18] = setRefElement;
    $[19] = t1;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}